import { RouteGroupRule } from '../../domain/models';
export class SeatPricingRuleWrapper extends RouteGroupRule {
  edited = false;
}
